export const AnalyticsLevels = {
  advanced: 'advanced',
  upload: 'upload',
  public_id: 'public_id',
  upload_widget: 'upload_widget',
  tags: 'tags',
  uw_presets: 'uw_presets',
};
